export default __webpack_public_path__ + "static/nexio-03ae9e097d85c415560f75de4cf41824.png";